import React from "react";
import { REQUEST_TYPES } from "@/lib/crmConstants";
import { Check } from "lucide-react";

export default function PipelineStepper({ requestType, stages, currentStage, onStageClick }) {
  const currentIdx = stages.indexOf(currentStage);
  return (
    <div className="w-full">
      <div className="flex items-center gap-0 flex-wrap">
        {stages.map((stage, i) => {
          const active = i <= currentIdx;
          const isCurrent = i === currentIdx;
          return (
            <React.Fragment key={stage}>
              <button
                type="button"
                data-testid={`stage-node-${stage.replace(/\s+/g, "-").toLowerCase()}`}
                onClick={() => onStageClick && onStageClick(stage)}
                className="flex flex-col items-center focus:outline-none group"
                style={{ minWidth: 92 }}
              >
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center font-mono text-xs border-2 transition-all ${
                    isCurrent
                      ? "bg-[#4F46E5] text-white border-[#4F46E5] scale-110 shadow-md"
                      : active
                      ? "bg-[#EEF2FF] text-[#4F46E5] border-[#C7D2FE]"
                      : "bg-white text-[#A1A1AA] border-[#E5E5E5]"
                  }`}
                >
                  {active && !isCurrent ? <Check className="w-4 h-4" /> : i + 1}
                </div>
                <div
                  className={`mt-2 text-[11px] font-medium max-w-[110px] text-center leading-tight ${
                    active ? "text-[#0A0A0A]" : "text-[#71717A]"
                  }`}
                >
                  {stage}
                </div>
              </button>
              {i < stages.length - 1 && (
                <div className={`pipeline-step-line ${i < currentIdx ? "active" : ""}`} style={{ minWidth: 20 }} />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}
